<template>
  <div class="row spinner-parent branch-offices-page">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>
            {{ source.title }}
          </h1>
        </div>
      </div>

      <div class="tabs">
        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">About</a>
        <a v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Contacts</a>
        <a v-on:click="activetab=3" v-bind:class="[ activetab === 3 ? 'active' : '' ]">News Notes</a>
        <a v-on:click="activetab=4" v-bind:class="[ activetab === 4 ? 'active' : '' ]">Announcements</a>
        <!-- <a v-on:click="activetab=5" v-bind:class="[ activetab === 5 ? 'active' : '' ]">Socials & Feature</a> -->
        <a v-on:click="activetab=6" v-bind:class="[ activetab === 6 ? 'active' : '' ]">Main Page</a>
        <a v-on:click="activetab=7" v-bind:class="[ activetab === 7 ? 'active' : '' ]">Center Page</a>
      </div>

      <div v-if="activetab === 1">
        <div class="card">
          <div class="card-header">
            <strong>About</strong>
          </div>
        </div>
        <about :entity="entity"></about>
      </div>

      <div v-if="activetab === 2">
        <div class="card">
          <div class="card-header">
            <strong>Contacts</strong>
          </div>
        </div>
        <contacts :entity="entity" :source="source"></contacts>
      </div>

      <div v-if="activetab === 3">
        <div class="card">
          <div class="card-header">
            <strong>News Notes</strong>
          </div>
        </div>
        <news></news>
      </div>

      <div v-if="activetab === 4">
        <div class="card">
          <div class="card-header">
            <strong>Announcements</strong>
          </div>
        </div>
        <announcements></announcements>
      </div>

      <!-- <div v-if="activetab === 5">
        <div class="card">
          <div class="card-header">
            <strong>Socials & Feature</strong>
          </div>
        </div>
        <social-feature :entity="entity" :source="source"></social-feature>
      </div> -->

      <div v-if="activetab === 6">
        <div class="card">
          <div class="card-header">
            <strong>Main Page</strong>
          </div>
        </div>
        <main-page :entity="entity" :source="source"></main-page>
      </div>

      <div v-if="activetab === 7">
        <div class="card">
          <div class="card-header">
            <strong>Center Page</strong>
          </div>
        </div>
        <center-page :entity="entity" :source="source"></center-page>
      </div>


    </div>
  </div>
  <!--/.row-->
</template>

<script>
import _ from 'lodash';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';

import About from './sections/About.vue';
import Contacts from './sections/Contacts.vue';
import News from './sections/news-notes/Index.vue';
import Announcements from './sections/announcements/Index.vue';
// import SocialFeature from './sections/SocialFeature.vue';
import MainPage from './sections/MainPage.vue';
import CenterPage from './sections/CenterPage.vue';

export default {
  name: 'BranchOfficesEdit',

  components: {
    About,
    Contacts,
    News,
    Announcements,
    // SocialFeature,
    MainPage,
    CenterPage,
  },

  mixins: [EditPageMixin],

  data() {
    return {
      activetab: 1,
      source: null,
      entity: {},
    };
  },

  methods: {
    isEntityValid() {
      function validateEmail(email) {
        // eslint-disable-next-line
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (!this.entity.domain) {
        this.$_showError('Abbreviation of Title must be valid');
        return false;
      }
      if (this.entity.contacts.director_email && !validateEmail(this.entity.contacts.director_email)) {
        this.$_showError('Director Email must be valid');
        return false;
      }
      return true;
    },
    getSource() {
      if (this.$refs.spinner) {
        this.$refs.spinner.show();
      }
      this.$apiHttp.get(`${this.$config.app_api.prefix}branch-offices/${this.$route.params.id}`, {
        params: {
          with: [
            'news_notes',
            'announcements',
            'images',
          ],
        },
      })
        .then((response) => {
          const newResponse = _.cloneDeep(response.data);
          if (newResponse.location == null) {
            newResponse.location = {
              lat: null,
              lng: null,
            };
          }
          // @todo: normalize phones, faxes and emails
          newResponse.contacts.phone1 = newResponse.contacts.phone['0'];
          newResponse.contacts.phone2 = newResponse.contacts.phone['1'];
          newResponse.contacts.fax1 = newResponse.contacts.fax['0'];
          newResponse.contacts.fax2 = newResponse.contacts.fax['1'];
          newResponse.contacts.email1 = newResponse.contacts.email['0'];
          newResponse.contacts.email2 = newResponse.contacts.email['1'];
          this.source = newResponse;
          this.entity = _.cloneDeep(newResponse);
          if (this.$refs.spinner) {
            this.$refs.spinner.hide();
          }
        })
        .catch((error) => {
          console.error(error);
          this.$store.dispatch('notifications/setHttpError', {
            error,
            text: 'Error in getting data request',
          });
          if (this.$refs.spinner) {
            this.$refs.spinner.hide();
          }
        });
    },
  },
};

</script>



// WEBPACK FOOTER //
// Edit.vue?e2407e82